<template>
  <vx-card no-shadow>
    <user-account-details-basic-information class=""></user-account-details-basic-information>

    <vs-divider
      class="my-base"
      border-height="2px"></vs-divider>

    <user-account-details-company-information></user-account-details-company-information>
  </vx-card>
</template>

<script>
import UserAccountDetailsBasicInformation
from '@/views/modules/user/user-account/user-account-details/UserAccountDetailsBasicInformation.vue';
import UserAccountDetailsCompanyInformation
from '@/views/modules/user/user-account/user-account-details/UserAccountDetailsCompanyInformation.vue';

export default {
  name: 'UserAccountDetails',
  components: { UserAccountDetailsBasicInformation, UserAccountDetailsCompanyInformation },
};
</script>

<style scoped lang="scss">

</style>
